import { render, staticRenderFns } from "./PainterInfoDialog.vue?vue&type=template&id=6bf2c150&scoped=true"
import script from "./PainterInfoDialog.vue?vue&type=script&lang=js"
export * from "./PainterInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./PainterInfoDialog.vue?vue&type=style&index=0&id=6bf2c150&prod&scoped=true&lang=scss"
import style1 from "./PainterInfoDialog.vue?vue&type=style&index=1&id=6bf2c150&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2c150",
  null
  
)

export default component.exports